import { createRouteHandlerClient } from './routeHandlerClient';

export const createServerActionClient = createRouteHandlerClient;
